export default function (v) {
    try {
        return v.value + " " + v.type;
    } catch (error) {
        return "";
    }
}